<template>
	<component :is="transition"
			   :tag="tag" group
			   v-bind="$attrs"
			   v-on="$listeners">
		<slot />
	</component>
</template>

<script lang="ts">
import Vue, { CreateElement } from "vue";
import { Component, Prop, Provide, Watch, Emit } from "vue-property-decorator";

@Component
export default class Sortable extends Vue {
	@Prop({ type: Array, default: () => [] }) value: any[];
	@Prop({ type: String, default: "v-list" }) tag: string;
	@Prop({ type: String, default: "v-slide-y-transition" }) transition: string;

	currentIdx: number = null;
	items: any[] = [];
	isDragging: boolean = false;

	@Watch("value", { immediate: true })
	onValueChanged() {
		this.items = this.value;
	}

	@Provide()
	get sortable() {
		return this;
	}

	setSortable(item: any) {
		this.currentIdx = this.items.indexOf(item);
		this.isDragging = true;
	}

	done() {
		this.currentIdx = null;
		this.isDragging = false;
	}

	setOver(item: any) {
		this.swap(item);
	}

	setDroppable(item: any) {
		this.swap(item);
	}

	private insertAt(item: any) {
		this.swap(item);
	}

	private swap(item: any) {
		const index = this.items.indexOf(item);
		if (index == this.currentIdx)
			return;

		// see: https://github.com/vuejs/vue/issues/4386
		// see: https://vuejs.org/v2/guide/list.html#Caveats

		const current = this.items[this.currentIdx];
		this.items.remove(current);

		this.items.splice(index, 0, current);
		this.currentIdx = index;
		this.$set(this.items, index, current);

		this.input();
	}

	@Emit()
	input() {
		return this.items;
	}
}
</script>

<style lang="scss">
</style>